(() => {
  'use strict';
  if (window.MMGriffatiMerchandising) return;
  const inspected = new WeakMap();
  const listening = new WeakSet();
  let queued = false;
  let expiryTimer = 0;

  function inspectImage(img) {
    if (!img.complete || !img.naturalWidth || !img.closest('[data-mm-packshot-candidate]')) return false;
    const source = img.currentSrc || img.src;
    if (inspected.get(img) === source) return img.classList.contains('mm-packshot-white');
    inspected.set(img, source);
    img.classList.remove('mm-packshot-white');
    try {
      const canvas = document.createElement('canvas');
      canvas.width = canvas.height = 32;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) return false;
      context.drawImage(img, 0, 0, 32, 32);
      const pixels = context.getImageData(0, 0, 32, 32).data;
      let total = 0;
      let white = 0;
      for (let y = 0; y < 32; y++) {
        for (let x = 0; x < 32; x++) {
          if (x > 1 && x < 30 && y > 1 && y < 30) continue;
          const i = (y * 32 + x) * 4;
          const r = pixels[i], g = pixels[i + 1], b = pixels[i + 2], a = pixels[i + 3];
          total++;
          if (a < 16 || (Math.min(r, g, b) >= 242 && Math.max(r, g, b) - Math.min(r, g, b) <= 12)) white++;
        }
      }
      const isWhite = white / total >= 0.9;
      img.classList.toggle('mm-packshot-white', isWhite);
      return isWhite;
    } catch {
      return false;
    }
  }

  function expireBadges() {
    clearTimeout(expiryTimer);
    const now = Date.now();
    let next = Infinity;
    document.querySelectorAll('[data-mm-scarcity-expires]').forEach(badge => {
      const expiry = Number(badge.dataset.mmScarcityExpires) * 1000;
      if (!Number.isFinite(expiry) || expiry <= now) badge.hidden = true;
      else next = Math.min(next, expiry - now);
    });
    if (Number.isFinite(next)) expiryTimer = setTimeout(expireBadges, Math.min(next + 1, 86400000));
  }

  function scan() {
    document.querySelectorAll('[data-mm-packshot-candidate] img').forEach(img => {
      if (!listening.has(img)) {
        listening.add(img);
        img.addEventListener('load', () => inspectImage(img));
      }
      inspectImage(img);
    });
    expireBadges();
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  }

  window.MMGriffatiMerchandising = { scan, inspectImage };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches('[data-mm-packshot-candidate], [data-mm-scarcity-expires], img') ||
      node.querySelector('[data-mm-packshot-candidate], [data-mm-scarcity-expires]'))))) schedule();
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
})();
